/* eslint-disable */

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { NavLink } from 'react-router-dom';
import { createConsumer, getConfig } from '@rails/actioncable';

import { WpPageLayout, WpPageBody } from 'Wpds/components/page-layout';
import { getRecommendationSettings } from 'Shared/actions/organizations';
import RecommendationSettingsPanel from './RecommendationSettingsPanel';
import TopNavigation from './components/TopNavigation/TopNavigation';

import './RecommendationSettings.scss';
class RecommendationSettings extends Component {
  state = {};

  cable = createConsumer(getConfig('url'));

  componentDidMount() {
    const { app, user_id, dispatch } = this.props;

    this.setState({ loading: false });
    window.analytics.track('Viewed NudgeBot Settings', {
      app_id: app.id,
    });

    dispatch(getRecommendationSettings());

    const that = this;

    if (!this.sidekiqJobChannel) {
      this.sidekiqJobChannel = this.cable.subscriptions.create(
        { channel: 'SidekiqJobChannel', user_id },
        {
          received: json => {
            if (json.request_id === that.props.recommendation_previews_request_id) {
              dispatch({
                type: 'RECOMMENDATION_PREVIEWS_GET_RESPONSE',
                payload: json,
              });
            }
          },
        }
      );
    }
  }

  componentWillUnmount() {
    if (this.sidekiqJobChannel) {
      this.sidekiqJobChannel.unsubscribe();
      this.sidekiqJobChannel = null;
    }
  }

  render() {
    const {
      recommendation_settings,
      any_salesforce_users_imported,
      salesforce_organization_data_source,
      user_email,
    } = this.props;

    const shouldShowSyncingWarning =
      recommendation_settings &&
      (!salesforce_organization_data_source ||
        salesforce_organization_data_source.sync_status.status == 'partial_historical_sync' ||
        salesforce_organization_data_source.sync_status.status == 'never_synced');

    const shouldShowUserMissingWarning = recommendation_settings && !any_salesforce_users_imported;

    return (
      <WpPageLayout width="full" className="SalesAssistantPage">
        <TopNavigation />
        <WpPageBody>
          <div>
            {shouldShowSyncingWarning ? (
              <div className="alert alert-warning ml-n5 pl-5 mr-n5 pr-5">
                <b>Note! </b>
                Your Salesforce instance is still being synced so the Preview button may show incomplete results.
              </div>
            ) : null}

            {shouldShowUserMissingWarning ? (
              <div className="alert alert-warning ml-n5 pl-5 mr-n5 pr-5">
                <b>Note! </b>
                You haven't added any users from Salesforce yet. Add them{' '}
                <NavLink to="/assistants/sales/import_salesforce_users">by clicking here.</NavLink>
              </div>
            ) : null}

            {(user_email.endsWith('@e-hps.com') ||
              user_email.endsWith('@mynd.co') ||
              user_email.endsWith('@impact.com') ||
              user_email.endsWith('@cordial.io') ||
              user_email.endsWith('@cordial.com') ||
              user_email.endsWith('@gomotive.com') ||
              user_email.endsWith('@workpatterns.com') ||
              user_email.endsWith('@workpatterns.ai')) && (
              <NavLink to="/assistants/sales/rule_builder" className="d-block p-4 border mb-2 text-center rounded">
                + Add custom nudge
              </NavLink>
            )}

            {recommendation_settings &&
              recommendation_settings
                .filter(recommendation_setting => recommendation_setting.recommendation_type.includes('Salesforce'))
                .map(recommendation_setting => (
                  <RecommendationSettingsPanel
                    key={recommendation_setting.name}
                    recommendation_setting_id={recommendation_setting.id}
                    settings={recommendation_setting.data}
                    recommendation_setting_name={recommendation_setting.name}
                    recommendation_klass_name={recommendation_setting.recommendation_type}
                  />
                ))}
          </div>
        </WpPageBody>
      </WpPageLayout>
    );
  }
}

const mapStateToProps = state => ({
  app: state.app,
  user_id: state.user.id,
  user_email: state.user.email,
  recommendation_settings: state.organization.recommendation_settings,
  recommendation_previews_request_id: state.recommendation_previews.request_id,
  any_salesforce_users_imported: state.organization.any_salesforce_users_imported,
  salesforce_organization_data_source: state.organization.salesforce_organization_data_source,
});

export default connect(mapStateToProps)(RecommendationSettings);
